import { SvgIcon, SvgIconProps } from '@mui/material';

export const MicrosoftIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M0 0h11v11H0zM13 0h11v11H13zM0 13h11v11H0zM13 13h11v11H13z" />
    </SvgIcon>
  );
};
